var _circle, _rect, _rect2, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _rect4, _rect5, _rect6, _circle11, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 96,
    viewBox: "0 0 92 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#EFF1F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 46,
    height: 10,
    rx: 1,
    fill: "#B1BADA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 41,
    width: 46,
    height: 10,
    rx: 1,
    fill: "#B1BADA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 54,
    width: 46,
    height: 10,
    rx: 1,
    fill: "#B1BADA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 33,
    r: 2,
    fill: "#EFF1F8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 46,
    r: 2,
    fill: "#EFF1F8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 59,
    r: 2,
    fill: "#EFF1F8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 33,
    r: 2,
    fill: "#EFF1F8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 46,
    r: 2,
    fill: "#EFF1F8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 59,
    r: 2,
    fill: "#EFF1F8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 2,
    fill: "#EFF1F8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 46,
    r: 2,
    fill: "#EFF1F8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 59,
    r: 2,
    fill: "#EFF1F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#EFF1F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 45.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#EFF1F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 58.5,
    width: 20,
    height: 1,
    rx: 0.5,
    fill: "#EFF1F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 83,
    r: 13,
    fill: "#FF4141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6513 78.8634C67.3584 79.1563 67.3584 79.6312 67.6513 79.9241L70.8332 83.106L67.7573 86.182C67.4644 86.4749 67.4644 86.9498 67.7573 87.2426C68.0501 87.5355 68.525 87.5355 68.8179 87.2426L71.8939 84.1667L75.0759 87.3487C75.3688 87.6416 75.8437 87.6416 76.1365 87.3487C76.4294 87.0558 76.4294 86.5809 76.1365 86.288L72.9545 83.106L76.2425 79.818C76.5354 79.5251 76.5354 79.0503 76.2425 78.7574C75.9496 78.4645 75.4748 78.4645 75.1819 78.7574L71.8939 82.0454L68.7119 78.8634C68.419 78.5705 67.9442 78.5705 67.6513 78.8634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.ba291fc5ef28e835a43351a662abd5a7.svg";
export { ForwardRef as ReactComponent };